import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    user_grade:"",
    user_id:"",
    user_seq:"",
    user_name:"",
    user_nickname:"",
    sort_data:{},
    profile_url:"",
    profile_thum_url:"",
    logo_url:"",
  },
  reducers: {
    removeUser: (state:any) => {
      state.user_id ="";
      state.user_seq ="";
      state.user_name ="";
      state.user_nickname ="";
      state.user_grade ="";
    },
    setUser: (state:any, action:any) => {
      for(let key in state){
        if(action.payload[key]!=undefined){
          state[key] =action.payload[key];
        }
      }
    }
  },
});

// Action creators are generated for each case reducer function
export const { removeUser,setUser } = userSlice.actions

export default userSlice.reducer